import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { SpsIncrementorComponent } from "../components/index";
import { SpsDSCoreModule } from "./sps-ds-core.module";

@NgModule({
    imports: [SpsDSCoreModule, FormsModule],
    exports: [SpsIncrementorComponent],
    declarations: [SpsIncrementorComponent]
})
export class SpsIncrementorModule {}
